module.exports = __webpack_public_path__ + "img/ethereum-alternative.2fa6927d.png";